import { onBeforeUnmount } from 'vue';

interface UseBackBlock {
  enableBackBlock: () => void
  disableBackBlock: () => void
}

export function useBackBlock(): UseBackBlock {
  if (import.meta.env.VITE_DISABLE_BACK_BLOCK === 'true' || !import.meta.client) {
    return {
      enableBackBlock: () => {},
      disableBackBlock: () => {},
    };
  }

  let cleanup = (): void => {};

  const enableBackBlock = (): void => {
    cleanup();

    const url = location.pathname + location.search + location.hash;
    history.pushState(null, '', url);

    const handler = () => history.go(1);
    window.addEventListener('popstate', handler);

    cleanup = (): void => {
      window.removeEventListener('popstate', handler);
    };
  };

  const disableBackBlock = (): void => {
    cleanup();
  };

  onBeforeUnmount(disableBackBlock);

  return { enableBackBlock, disableBackBlock };
}
